
import { useCallback } from "react";

interface NodeEventHandlersProps {
  id: string;
  updateNodeData: (id: string, data: any) => void;
  onNodeSelect?: (nodeId: string) => void;
  onNodeDelete?: (nodeId: string) => void;
  isClientMode?: boolean;
}

export const useNodeEventHandlers = ({
  id,
  updateNodeData,
  onNodeSelect,
  onNodeDelete,
  isClientMode = false
}: NodeEventHandlersProps) => {
  const handleCategoryChange = useCallback((category: string) => {
    console.log("NodeEventHandlers - handleCategoryChange called:", { 
      nodeId: id, 
      newCategory: category, 
      hasUpdateFunction: typeof updateNodeData === 'function'
    });
    
    if (typeof updateNodeData !== 'function') {
      console.error("updateNodeData is not a function for node:", id);
      return;
    }
    
    try {
      const updateData = { 
        category: category,
        lastEdited: Date.now(),
        editedBy: isClientMode ? 'client' : 'owner'
      };
      console.log("Calling updateNodeData with:", updateData);
      updateNodeData(id, updateData);
      console.log("Category update successful for node:", id);
    } catch (error) {
      console.error("Error updating category for node:", id, error);
    }
  }, [id, updateNodeData, isClientMode]);

  const handleNodeSelect = useCallback((e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    console.log("Node select triggered for:", id);
    if (onNodeSelect && typeof onNodeSelect === 'function') {
      try {
        onNodeSelect(id);
        console.log("Node selection successful");
      } catch (error) {
        console.error("Error selecting node:", error);
      }
    } else {
      console.warn("onNodeSelect function not available for node:", id);
    }
  }, [id, onNodeSelect]);

  const handleNodeDelete = useCallback((e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    console.log("Node delete triggered for:", id);
    if (onNodeDelete && typeof onNodeDelete === 'function') {
      try {
        onNodeDelete(id);
        console.log("Node deletion successful");
      } catch (error) {
        console.error("Error deleting node:", error);
      }
    } else {
      console.warn("onNodeDelete function not available for node:", id);
    }
  }, [id, onNodeDelete]);

  return {
    handleCategoryChange,
    handleNodeSelect,
    handleNodeDelete
  };
};
